<template>
  <article class="comment -placeholder">
    <i class="icon -loading" aria-hidden="true" /><span class="sr-only">Loading</span>
  </article>
</template>

<script>
// @flow
export default {}
</script>
